<template>
  <div class="green-overlay">
    <div class="notification-card">
      <img class ='check-icon'
        :src="require('@/assets/icons/icon-green-check.svg')"
        alt="check icon"
      />
      {{ message }}
      <router-link tag="h6" class="pointer" :to="linkDestination" exact>
        <button class="confirm-button">ACEPTAR</button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: ['message', 'link'],
  data(){
    return {
      linkDestination: '/containerview'
    }
  },
  mounted () {
    this.checkLink()
  },
  methods: {
    checkLink: function(){
      if (this.link != undefined) {
        this.linkDestination = this.link
      }
    }
  }
}
</script>

<style lang= "scss" scoped>
  .green-overlay {
    height: 100vh;
    width: 100vw;
    background-color: rgba(50,172,145,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }
  .notification-card {
    width: 250px;
    height: 250px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0px 3px 10px rgba(0,0,0,0.3);
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: $grey2;
    font-weight: 600;
    text-align: center;
  }
  .check-icon {
    width: 30px;
    margin-bottom: 16px;
  }
  .confirm-button {
    background-color: $button-background;
    border: none;
    color: white;
    padding: 12px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin-top: 25px;
    border-radius: 25px;
    width: 100%;
    box-shadow: 0px 3px 6px rgba(0,0,0,0.3);
  }
</style>

